import React, { useEffect, useState } from "react";
import URL from "../../../../Main/url";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const InvoiceA5Header = React.forwardRef((props, ref) => {
  const { values } = props;

  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 7;

  const calculateTotalPages = () => {
    if (!values?.details) return 1;
    return Math.ceil(values.details.length / itemsPerPage);
  };

  const getItemsForPage = (page) => {
    if (!values?.details) return [];
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return values.details.slice(startIndex, endIndex);
  };

  useEffect(() => {
    if (values?.details) {
      const pages = calculateTotalPages();
      setTotalPages(pages);
    }
  }, [values?.details]);

  console.log("total pages", totalPages)

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A5 landscape;
        margin: 0% 5% 1% 5%;
      }
  
      @media print {
        .a5-header-section {
          position: fixed;
          top: 0%;
          left: 0%;
          right: 0%;
          background: white;
          z-index: 1000;
          page-break-inside: avoid;
        }
        
        .a5-table-header-section {
          position: fixed;
          top: 25%; 
          left: 0%;
          right: 0%;
          background: white;
          z-index: 999;
          page-break-inside: avoid;
        }
        
        .a5-invoice-content {
          margin-top: 30%; 
          left: 0%;
          right: 0%;
          margin-right:0.5cm;
        }
        
        .a5-page-break {
          page-break-before: always;
          margin-top: 30%;
        }
        
        .a5-landscape {
          page: a5-landscape;
        }

        .a5-totals-wrapper {
    position: relative; 
  margin-top: 4rem; 
    left: 0cm;
    right: 0cm;
    page-break-inside: avoid;
  }

  .a5-totals-wrapper.with-header-gap {
    padding-top: 0; 
  }

         .a5-totals {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .invoice-table {
  width: 100%;
  table-layout: fixed;
}

.col-sno     { width: 4%; }
.col-desc    { width: 35%; }   
.col-batch   { width: 8%; }    
.col-expiry  { width: 10%; }   
.col-unit    { width: 8%; }    
.col-qty     { width: 8%; }
.col-price   { width: 8%; }
.col-vat     { width: 6%; }
.col-total   { width: 8%; }


      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    if (values?.branch?.name) {
      injectScopedStyles();
    }
  }, [values?.branch?.name]);

  const renderHeaderSection = () => (
    <div className="a5-header-section">
      <div className="text-black-900 text-[0.65rem]">
        <div className="flex items-center justify-between w-full">
          {values?.branch?.image && (
            <div className="flex-shrink-0">
              <img
                className="w-[55px] h-[55px] object-contain border rounded"
                src={`${URL}/uploads${values?.branch?.image}`}
              />
            </div>
          )}
          <div className="flex flex-col text-left leading-tight">
            <div className="text-xl font-medium">
              {values?.branch?.name}
            </div>
            <div>
              {values?.branch?.category}
            </div>
            <div>
              Email : {values?.branch?.email || ""}
              {values?.branch?.email && values?.branch?.phone ? " | " : ""}
              Phone : {values?.branch?.phone || ""}
            </div>
            <div>
              {values?.branch?.area || ""}
              {values?.branch?.area && values?.branch?.city ? ", " : ""}
              {values?.branch?.city || ""}
              {values?.branch?.city && values?.branch?.country ? ", " : ""}
              {values?.branch?.country || ""}
            </div>
            <div>
              VATIN : {values?.branch?.tax || ""}
            </div>
          </div>
        </div>
      </div>

      <hr className="my-1 border-t border-gray-400" />
      <div className="text-[0.9rem] font-semibold text-center text-gray-700 tracking-wide">
        TAX INVOICE
      </div>
      <hr className="my-1 border-t border-gray-400" />

      <div className="text-[0.7rem] leading-tight mt-2">
        <div className="flex justify-between">
          <div>
            <table className="leading-tight">
              <tbody>
                <tr>
                  <td className="pr-1 whitespace-nowrap">Customer</td>
                  <td className="px-1">:</td>
                  <td className="text-right whitespace-nowrap">
                    {values?.customer?.name || "Walk-in-customer"}
                  </td>
                </tr>

                <tr>
                  <td className="pr-1 whitespace-nowrap">Phone</td>
                  <td className="px-1">:</td>
                  <td className="text-right whitespace-nowrap">
                    {values?.customer?.phone || ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table className="leading-tight">
              <tbody>
                <tr>
                  <td className="pr-1 whitespace-nowrap">Invoice No</td>
                  <td className="px-1">:</td>
                  <td className="text-right whitespace-nowrap">
                    #INV-{values?.number}
                  </td>
                </tr>

                <tr>
                  <td className="pr-1 whitespace-nowrap">Date</td>
                  <td className="px-1">:</td>
                  <td className="text-right whitespace-nowrap">
                    {formatDateDDMMYYYY?.(values?.date)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  const renderTableHeaders = () => (
    <div className="a5-table-header-section">
      <table className="invoice-table" style={styles.table}>
        <thead>
          <tr style={styles.tableHeader}>
            <th
              className="col-sno text-left pl-2 text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              S.No
            </th>
            <th
              className="col-desc text-left text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Description
            </th>
            <th
              className="col-batch text-left text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Batch
            </th>
            <th
              className="col-expiry text-left text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Expiry
            </th>
            <th
              className="col-unit text-left text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Unit
            </th>
            <th
              className="col-qty text-left text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Quantity
            </th>
            <th
              className="col-price text-left text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Price
            </th>
            <th
              className="col-vat  text-left text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Tax
            </th>
            <th
              className="col-total text-right text-xs text-regular"
              style={styles.tableHeaderCell}
            >
              Total
            </th>
          </tr>
        </thead>
      </table>
    </div>
  );

  const renderTableBody = (pageItems, pageNumber, isLastPage) => (
    <div
      key={`page-${pageNumber}`}
      className={pageNumber > 1 ? "a5-page-break" : "a5-invoice-content"}
    >
      <table className="invoice-table" style={styles.table}>
        <tbody className="text-regular">
          {pageItems.map((item, index) => {
            const globalIndex = (pageNumber - 1) * itemsPerPage + index;
            return (
              <tr key={index}>
                <td className="col-sno text-left pl-2 text-xs" style={styles.tableCell}>
                  <div>{globalIndex + 1}</div>
                </td>
                <td className="col-desc text-left text-xs" style={styles.tableCell}>
                  <div>{item?.name}</div>
                </td>
                <td className="col-batch text-left text-xs" style={styles.tableCell}>
                  <div>
                    {item?.description?.number
                      ? `${item?.description?.number}`
                      : ""}
                  </div>
                </td>
                <td className="col-expiry text-left text-xs" style={styles.tableCell}>
                  <div>
                    {item?.description?.expiry_date
                      ? `${formatDateDDMMYYYY?.(item?.description?.expiry_date)}`
                      : ""}
                  </div>
                </td>
                <td className="col-unit text-left text-xs" style={styles.tableCell}>
                  {item?.unit_name}
                </td>
                <td className="col-qty text-left text-xs" style={styles.tableCell}>
                  {item?.quantity}
                </td>
                <td className="col-price text-left text-xs" style={styles.tableCell}>
                  {item?.sale_price?.toFixed(3)}
                </td>
                <td className="col-vat text-left text-xs" style={styles.tableCell}>
                  {item?.tax_amount?.toFixed(3)}
                </td>
                <td
                  className="col-total text-right pr-2 text-xs"
                  style={styles.tableCell}
                >
                  {item?.total?.toFixed(3)}
                </td>
              </tr>
            );
          })}

          {/*  {pageItems.length < itemsPerPage &&
            Array.from({ length: itemsPerPage - pageItems.length }).map((_, index) => (
              <tr key={`empty-${pageNumber}-${index}`}>
                <td className="text-left pl-2 text-xs" style={styles.tableCell}>
                  &nbsp;
                </td>
                <td className="text-left text-xs" style={styles.tableCell}>&nbsp;</td>
                <td className="text-left text-xs" style={styles.tableCell}>&nbsp;</td>
                <td className="text-left text-xs" style={styles.tableCell}>&nbsp;</td>
                <td className="text-left text-xs" style={styles.tableCell}>&nbsp;</td>
                <td className="text-left text-xs" style={styles.tableCell}>&nbsp;</td>
                <td className="text-left text-xs" style={styles.tableCell}>&nbsp;</td>
                <td className="text-left text-xs" style={styles.tableCell}>&nbsp;</td>
                <td className="text-left text-right pr-2 text-xs" style={styles.tableCell}>&nbsp;</td>
              </tr>
            ))
          } */}
        </tbody>
      </table>

      {isLastPage && (
        <div className={`a5-totals-wrapper ${pageItems.length === itemsPerPage ? "with-header-gap" : ""
          }`}>
          <div className="a5-totals">
            <table className="invoice-table" style={styles.table}>
              <tbody className="text-medium">
                <tr style={styles.totalRow}>
                  <td
                    className="text-xs text-gray-700"
                    style={styles.tableCell}
                    colSpan="8"
                    align="right"
                  >
                    Subtotal
                  </td>
                  <td className="text-right pr-2 text-xs" style={styles.tableCell}>
                    {values?.subtotal?.toFixed(3)}
                  </td>
                </tr>
                <tr style={styles.totalRow}>
                  <td
                    className="text-xs text-gray-700"
                    style={styles.tableCell}
                    colSpan="8"
                    align="right"
                  >
                    Tax [VAT]
                  </td>
                  <td className="text-right pr-2 text-xs" style={styles.tableCell}>
                    {values?.taxamount?.toFixed(3)}
                  </td>
                </tr>
                <tr style={styles.totalRow}>
                  <td
                    className="text-xs text-gray-700"
                    style={styles.tableCell}
                    colSpan="8"
                    align="right"
                  >
                    Discount
                  </td>
                  <td className="text-right pr-2 text-xs" style={styles.tableCell}>
                    {values?.discount?.toFixed(3)}
                  </td>
                </tr>
                {/* Total */}
                <tr style={styles.totalRow}>
                  <td
                    className="text-xs bg-[#f0f0f0] font-medium"
                    style={styles.tableCell}
                    colSpan="8"
                    align="right"
                  >
                    Total
                  </td>
                  <td
                    className="text-right pr-2 text-xs bg-[#f0f0f0] font-medium"
                    style={styles.tableCell}
                  >
                    {values?.total?.toFixed(3)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div className="a5-landscape" ref={ref} style={styles.container}>
      <style>
        {`
          @page a5-landscape {
            size: A5 landscape;
            margin-top: 0.5cm;
            margin-bottom: 1cm;
            margin-left: 0.5cm;
            margin-right: 0.5cm;
          }
          
          @media print {
            .a5-landscape {
              width: 100%;
              height: 100%;
              page-break-inside: avoid;
            }

            .a5-landscape + * {
              display: none !important;
            }
            
            .a5-header-section {
              position: fixed;
              top: 0cm;
              left: 0.5cm;
              right: 0.5cm;
              background: white;
              z-index: 1000;
              page-break-inside: avoid;
            }
            
            .a5-table-header-section {
              position: fixed;
              top: 5cm;
              left: 0.5cm;
              right: 0.5cm;
              background: white;
              z-index: 999;
              page-break-inside: avoid;
            }
            
            .a5-invoice-content {
              margin-top: 6cm;
              margin-left: 0.5cm;
              margin-right: 0.5cm;
            }
            
            .a5-page-break {
              page-break-before: always;
              margin-top: 6cm;
              margin-left: 0.5cm;
              margin-right: 0.5cm;
            }
            
            .a5-landscape {
              page: a5-landscape;
            }
          }
          
          @media screen {
            .a5-header-section {
              position: static;
            }
            
            .a5-table-header-section {
              position: static;
            }
            
            .a5-invoice-content {
              margin-top: 0;
            }
            
            .a5-page-break {
              margin-top: 0;
              page-break-before: auto;
            }
           
            .invoice-table {
  width: 100%;
  table-layout: fixed;
}

.col-sno     { width: 4%; }
.col-desc    { width: 35%; }   /* reduced */
.col-batch   { width: 8%; }    /* reduced */
.col-expiry  { width: 10%; }   /* increased */
.col-unit    { width: 8%; }    /* increased */
.col-qty     { width: 8%; }
.col-price   { width: 8%; }
.col-vat     { width: 6%; }
.col-total   { width: 8%; }

          }
        `}
      </style>

      {renderHeaderSection()}

      {renderTableHeaders()}

      {Array.from({ length: totalPages }, (_, i) => i + 1).map(pageNumber => {
        const pageItems = getItemsForPage(pageNumber);
        const isLastPage = pageNumber === totalPages;
        console.log("in array", pageItems, pageNumber, isLastPage)
        return renderTableBody(pageItems, pageNumber, isLastPage);
      })}
    </div>
  );
});

const styles = {
  container: {
    width: "100%",
    height: "100%",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: "#f0f0f0",
  },
  tableHeaderCell: {
    padding: "5px",
    fontSize: "0.65rem",
    fontWeight: "600",
  },

  tableBodyCell: {
    padding: "5px",
    fontSize: "0.65rem",
    fontWeight: "400",
    textAlign: "left",
  },
  totalRow: {
    fontWeight: "normal",
  },
};

export default InvoiceA5Header;